import type { AllRouteEndpoints } from "../routeTypes";

export const conversationalWorkflow = "/:app_group_id/conversational/workflow/:id";

export const conversationalWorkflowCacheKeys: AllRouteEndpoints[] = [
  "/:app_group_id/conversational/workflow/:id",
  "/:app_group_id/conversational/workflows",
];
